import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import uuid from 'uuid'
import { get } from 'lodash'
import { TasksAssignLeader } from 'containers/forms/tasks'
import { Table, Data } from 'components/layout/Table'
import { tasks as tasksLayout } from 'constants/layout'
import config from 'config'

export default class TasksUnassignedParticipantsTableSingle extends Component {
  static propTypes = {
    data: PropTypes.object.isRequired,
    modal: PropTypes.func.isRequired,
    assignLeader: PropTypes.func.isRequired
  }

  state = {
    awardIdSignoff: null,
    awardIdReturn: null
  }

  key = uuid.v1()

  handleApproveModal = awardIdSignoff => {
    this.setState(
      {
        awardIdSignoff
      },
      () => {
        this.props.modal(`modal-signoff-activity-${this.key}`)
      }
    )
  }

  handleReturnModal = awardIdReturn => {
    this.setState(
      {
        awardIdReturn
      },
      () => {
        this.props.modal(`modal-return-activity-${this.key}`)
      }
    )
  }

  render() {
    const { data, assignLeader } = this.props

    return (
      <div>
        <Table ths={tasksLayout.awardsUnassignedSingle}>
          <Data>
            <tr>
              <td>
                <Link to={`${config.publicPath}/participants/${get(data, 'participant.id')}`}>
                  {get(data, 'participant.globalId') ||
                    get(data, 'participant.id')}
                </Link>
              </td>
              <td>{get(data, 'participant.firstName')}</td>
              <td>{get(data, 'participant.lastName')}</td>
              <td>{get(data, 'participant.email')}</td>
              <td>
                <TasksAssignLeader
                  assignLeader={assignLeader}
                  id={get(data, 'id')}
                  form={`leaderAssigmentForm-${get(data, 'id')}`}
                  decoOrganizationId={get(data, 'organization.id')}
                />
              </td>
            </tr>
          </Data>
        </Table>
      </div>
    )
  }
}
